// extracted by mini-css-extract-plugin
module.exports = {"pageNotFound":"styles_pageNotFound__17PGg","svg":"styles_svg__24cFC","homePageButton":"styles_homePageButton__2zwAW"};